var map = {
	"./circulo-ovalado-01.png": 3552,
	"./rectangulo-01.png": 1302,
	"./reloj-de-arena-01.png": 5194,
	"./torso-chico-01.png": 6225,
	"./torso-largo-01.png": 9525,
	"./torso-todo-tipo.png": 4939,
	"./triangulo-01.png": 6474,
	"./triangulo-invertido-01.png": 7751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9664;